(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./_util/proptype"), require("./icon"), require("./button"));
	else if(typeof define === 'function' && define.amd)
		define(["./_util/proptype", "./icon", "./button"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./_util/proptype"), require("./icon"), require("./button")) : factory(root["./_util/proptype"], root["./icon"], root["./button"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 84);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/defineProperty");

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _style_index_less__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(122);
/* harmony import */ var _style_index_less__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_index_less__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(165);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);



/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./components/input/style/index.js
var style = __webpack_require__(48);

// EXTERNAL MODULE: external "babel-runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "./_util/proptype"
var proptype_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/input/input.vue?vue&type=script&lang=js&




var SIZEMAP = {
  'small': 'sm',
  'large': 'lg',
  'default': '',
  'medium': 'md',
  'mini': 'mni'
};

/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'MdsInput',
  props: {
    addonAfter: String,
    addonBefore: String,
    autocomplete: {
      type: String,
      default: 'off'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    number: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    prefix: String,
    prefixCls: {
      type: String,
      default: 'mds-input'
    },
    bulefixCls: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: function validator(value) {
        return Object(proptype_["oneOf"])(value, ['small', 'large', 'default', 'mini', 'medium']);
      },

      default: 'default'
    },
    suffix: String,
    type: {
      type: String
    },
    value: null
  },
  computed: {
    inputClass: function inputClass() {
      var _ref;

      var size = this.size && SIZEMAP[this.size];
      return [this.prefixCls, (_ref = {}, defineProperty_default()(_ref, this.prefixCls + '-' + size, !!size), defineProperty_default()(_ref, this.prefixCls + '-disabled', !!this.disabled), _ref)];
    },
    showAddonAfter: function showAddonAfter() {
      return this.addonAfter || this.$slots.addonAfter !== undefined;
    },
    showAddonBefore: function showAddonBefore() {
      return this.addonBefore || this.$slots.addonBefore !== undefined;
    },
    showPrefix: function showPrefix() {
      return this.prefix || this.$slots.prefix !== undefined;
    },
    showSuffix: function showSuffix() {
      return this.suffix || this.$slots.suffix !== undefined;
    }
  },
  render: function render(h) {
    var _this = this;

    // bug hack from https://github.com/vuejs/vue/blob/dev/src/platforms/web/util/attrs.js#L10-L18
    var basicInput = h('input', {
      attrs: {
        type: this.type,
        value: this.value,
        placeholder: this.placeholder,
        readonly: this.readonly,
        name: this.name,
        number: this.number,
        autofocus: this.autofocus,
        disabled: this.disabled,
        id: this.id,
        autocomplete: this.autocomplete
      },
      domProps: {
        value: this.value
      },
      'class': this.inputClass,
      'ref': 'input',
      on: {
        blur: this.handleBlur,
        change: this.handleChange,
        click: this.handleClick,
        focus: this.handleFocus,
        input: this.updateValue,
        keypress: this.handleKeyDown
      }
    });

    var renderLabeledInput = function renderLabeledInput(children) {
      if (!_this.showAddonBefore && !_this.showAddonAfter) {
        return children;
      }

      var wrapperClassName = _this.prefixCls + '-group';
      var addonClassName = _this.bulefixCls === 'blue' ? wrapperClassName + '-blue-addon' : wrapperClassName + '-addon';
      var addonBefore = h('span', { 'class': addonClassName }, [_this.$slots.addonBefore || _this.addonBefore]);
      var addonAfter = h('span', { 'class': addonClassName }, [_this.$slots.addonAfter || _this.addonAfter]);

      var className = [_this.prefixCls + '-wrapper', defineProperty_default()({}, wrapperClassName, addonBefore || addonAfter)];

      if (_this.showAddonBefore || _this.showAddonAfter) {
        return h('span', { 'class': _this.prefixCls + '-group-wrapper' }, [h('span', { 'class': className }, [_this.showAddonBefore ? addonBefore : null, children, _this.showAddonAfter ? addonAfter : null])]);
      }
      return h('span', { 'class': className }, [children]);
    };

    var renderLabeledIcon = function renderLabeledIcon(children) {
      if (!(_this.showSuffix || _this.showPrefix)) {
        return children;
      }
      var prefix = h('span', { 'class': _this.prefixCls + '-prefix' }, [_this.$slots.prefix || _this.prefix]);
      var suffix = h('span', { 'class': _this.prefixCls + '-suffix' }, [_this.$slots.suffix || _this.suffix]);
      return h('span', { 'class': [_this.prefixCls + '-affix-wrapper'] }, [_this.showPrefix ? prefix : null, children, _this.showSuffix ? suffix : null]);
    };

    var renderInput = function renderInput() {
      return renderLabeledIcon(basicInput);
    };

    return renderLabeledInput(renderInput());
  },

  methods: {
    getInput: function getInput() {
      return this.$refs.input;
    },
    focus: function focus() {
      this.getInput().focus();
    },
    handleKeyDown: function handleKeyDown(e) {
      if (e.keyCode === 13) {
        this.$emit('press-enter', e);
      }
      this.$emit('keydown', e);
    },
    updateValue: function updateValue(e) {
      this.$emit('input', e.target.value);
    },
    handleBlur: function handleBlur(e) {
      this.$emit('blur', e);
    },
    blur: function blur(e) {
      this.$refs.input.blur();
      this.$emit('blur', e);
    },
    handleFocus: function handleFocus(e) {
      this.$emit('focus', e);
    },
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    },
    handleChange: function handleChange(e) {
      this.$emit('change', e);
    }
  }
});
// CONCATENATED MODULE: ./components/input/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var input_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./components/input/input.vue
var input_render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  input_inputvue_type_script_lang_js_,
  input_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "components/input/input.vue"
/* harmony default export */ var input = (component.exports);
// EXTERNAL MODULE: external "./icon"
var external_icon_ = __webpack_require__(4);
var external_icon_default = /*#__PURE__*/__webpack_require__.n(external_icon_);

// EXTERNAL MODULE: external "./button"
var external_button_ = __webpack_require__(6);
var external_button_default = /*#__PURE__*/__webpack_require__.n(external_button_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/input/search.vue?vue&type=script&lang=js&




// 兼容buttonsize
var BUTTONSIZE = {
  'small': 'small',
  'large': 'large',
  'mini': 'large-small'
};
/* harmony default export */ var searchvue_type_script_lang_js_ = ({
  name: 'MdsInputSearch',
  props: {
    addonAfter: String,
    addonBefore: String,
    autocomplete: {
      type: String,
      default: 'off'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    className: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    number: {
      type: Boolean,
      default: false
    },
    enterButton: {
      type: Boolean,
      default: false
    },
    enterButtonText: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    prefix: String,
    prefixCls: {
      type: String,
      default: 'mds-input'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: String,
    suffix: String,
    type: {
      type: String
    },
    value: null
  },
  render: function render(h) {
    var _this = this;

    var searchIcon = h(external_icon_default.a, {
      props: {
        type: 'line-search'
      },
      'class': 'mds-input-search-icon',
      slot: 'suffix',
      nativeOn: {
        click: function click() {
          _this.$emit('search', _this.value);
        }
      }
    });
    var searchBtn = h(external_button_default.a, {
      props: {
        type: 'primary',
        icon: this.enterButtonText ? '' : 'line-search',
        size: BUTTONSIZE[this.size]
      },
      slot: 'addonAfter',
      nativeOn: {
        click: function click() {
          _this.$emit('search', _this.value);
        }
      }
    }, this.enterButtonText);
    var renderArr = [];
    if (this.enterButton) {
      renderArr.push(searchBtn);
    } else {
      renderArr.push(searchIcon);
    }
    return h(input, {
      props: this.$props,
      'class': 'mds-input-search',
      on: {
        input: function input(value) {
          return _this.$emit('input', value);
        },
        'press-enter': function pressEnter() {
          return _this.$emit('search', _this.value);
        }
      }
    }, renderArr);
  }
});
// CONCATENATED MODULE: ./components/input/search.vue?vue&type=script&lang=js&
 /* harmony default export */ var input_searchvue_type_script_lang_js_ = (searchvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/input/search.vue
var search_render, search_staticRenderFns




/* normalize component */

var search_component = Object(componentNormalizer["a" /* default */])(
  input_searchvue_type_script_lang_js_,
  search_render,
  search_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var search_api; }
search_component.options.__file = "components/input/search.vue"
/* harmony default export */ var search = (search_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./components/input/textarea.vue?vue&type=template&id=5786ca5a&
var textareavue_type_template_id_5786ca5a_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("textarea", {
    ref: "textAreaRef",
    class: _vm.prefixCls,
    attrs: { rows: "4" },
    on: {
      input: _vm.handleInput,
      keypress: _vm.handleKeyDown,
      change: _vm.handleChange
    }
  })
}
var textareavue_type_template_id_5786ca5a_staticRenderFns = []
textareavue_type_template_id_5786ca5a_render._withStripped = true


// CONCATENATED MODULE: ./components/input/textarea.vue?vue&type=template&id=5786ca5a&

// CONCATENATED MODULE: ./components/input/calculateNodeHeight.js
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */

var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n';

var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

var computedStyleCache = {};
var hiddenTextarea = void 0;

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);

  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var sizingStyle = SIZING_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  // Fix wrap="off" issue
  // https://github.com/mds-design/mds-design/issues/6577
  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  }

  // Copy all CSS properties that have an impact on the height of the content in
  // the textbox

  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle;

  // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';

  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;
  var overflowY = void 0;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = '';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }
  // Remove scroll bar flash when autosize without maxRows
  if (!maxRows) {
    overflowY = 'hidden';
  }
  return { height: height + 'px', minHeight: minHeight, maxHeight: maxHeight, overflowY: overflowY };
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/input/textarea.vue?vue&type=script&lang=js&
//
//
//
//



function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(cb);
  }
  return window.setTimeout(cb, 1);
}

function clearNextFrameAction(nextFrameId) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(nextFrameId);
  } else {
    window.clearTimeout(nextFrameId);
  }
}

/* harmony default export */ var textareavue_type_script_lang_js_ = ({
  name: 'MdsInputTextarea',
  props: {
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    prefixCls: {
      type: String,
      default: 'mds-input'
    },
    value: null
  },
  data: function data() {
    return {
      textareaStyles: {}
    };
  },

  methods: {
    handleChange: function handleChange(e) {
      this.$emit('change', e);
    },
    handleInput: function handleInput(e) {
      if (this.nextFrameActionId) {
        clearNextFrameAction(this.nextFrameActionId);
      }
      this.nextFrameActionId = onNextFrame(this.resizeTextarea);
      this.$emit('input', e.target.value);
    },
    handleKeyDown: function handleKeyDown(e) {
      if (e.keyCode === 13) {
        this.$emit('press-enter', e);
      }
      this.$emit('keydown', e);
    },
    resizeTextarea: function resizeTextarea() {
      if (!this.autosize) {
        return false;
      }
      var minRows = this.autosize ? this.autosize.minRows : null;
      var maxRows = this.autosize ? this.autosize.maxRows : null;
      this.textareaStyles = calculateNodeHeight(this.$refs.textAreaRef, false, minRows, maxRows);
    }
  },
  mounted: function mounted() {
    this.resizeTextarea();
  }
});
// CONCATENATED MODULE: ./components/input/textarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var input_textareavue_type_script_lang_js_ = (textareavue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/input/textarea.vue





/* normalize component */

var textarea_component = Object(componentNormalizer["a" /* default */])(
  input_textareavue_type_script_lang_js_,
  textareavue_type_template_id_5786ca5a_render,
  textareavue_type_template_id_5786ca5a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var textarea_api; }
textarea_component.options.__file = "components/input/textarea.vue"
/* harmony default export */ var input_textarea = (textarea_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./components/input/group.vue?vue&type=template&id=9e2c1de2&
var groupvue_type_template_id_9e2c1de2_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: _vm.classes }, [_vm._t("default")], 2)
}
var groupvue_type_template_id_9e2c1de2_staticRenderFns = []
groupvue_type_template_id_9e2c1de2_render._withStripped = true


// CONCATENATED MODULE: ./components/input/group.vue?vue&type=template&id=9e2c1de2&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/input/group.vue?vue&type=script&lang=js&

//
//
//
//
//
//



/* harmony default export */ var groupvue_type_script_lang_js_ = ({
  name: 'MdsInputGroup',
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    conjoined: {
      type: Boolean,
      default: false
    },
    prefixCls: {
      type: String,
      default: 'mds-input-group'
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return Object(proptype_["oneOf"])(value, ['default', 'small', 'large']);
      }
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      return [this.prefixCls, (_ref = {}, defineProperty_default()(_ref, this.prefixCls + '-lg', this.size === 'large'), defineProperty_default()(_ref, this.prefixCls + '-sm', this.size === 'small'), defineProperty_default()(_ref, this.prefixCls + '-compact', this.compact), defineProperty_default()(_ref, this.prefixCls + '-conjoined', this.conjoined), _ref)];
    }
  }
});
// CONCATENATED MODULE: ./components/input/group.vue?vue&type=script&lang=js&
 /* harmony default export */ var input_groupvue_type_script_lang_js_ = (groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/input/group.vue





/* normalize component */

var group_component = Object(componentNormalizer["a" /* default */])(
  input_groupvue_type_script_lang_js_,
  groupvue_type_template_id_9e2c1de2_render,
  groupvue_type_template_id_9e2c1de2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var group_api; }
group_component.options.__file = "components/input/group.vue"
/* harmony default export */ var group = (group_component.exports);
// CONCATENATED MODULE: ./components/input/index.js






input.Group = group;
input.Search = search;
input.TextArea = input_textarea;
/* istanbul ignore next */
input.install = function (Vue) {
  Vue.component(input.name, input);
  Vue.component(search.name, search);
  Vue.component(group.name, group);
  Vue.component(input_textarea.name, input_textarea);
};
/* harmony default export */ var components_input = __webpack_exports__["default"] = (input);

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/input.js
// module id = OURa
// module chunks = 0